import type { SemanticStep } from '~/replay/eventCompression';

import type { HistorySelectionIntent } from './HistoryTimeline';

/**
 * Resolves the current cursor/selection into a canonical form:
 * - 'semantic' with originalIndex when a semantic step is selected
 * - 'live' when at live or past end
 * - null when selection doesn't map to a semantic step
 */
export function resolveCursorSelection({
  selectedIndex,
  eventLogLength,
  semanticSteps,
  selectionIntent,
}: {
  selectedIndex: number | null;
  eventLogLength: number;
  semanticSteps: SemanticStep[];
  selectionIntent?: HistorySelectionIntent;
}) {
  if (selectionIntent?.kind === 'semantic') {
    return { kind: 'semantic', originalIndex: selectionIntent.originalIndex } as const;
  }
  if (selectionIntent?.kind === 'live') {
    return { kind: 'live' } as const;
  }
  if (selectedIndex === null || selectedIndex >= eventLogLength) {
    return { kind: 'live' } as const;
  }
  const step = semanticSteps.find((s) => s.targetEventIndex === selectedIndex);
  if (step) {
    return { kind: 'semantic', originalIndex: step.originalIndex } as const;
  }
  return null;
}
